export const setupWizard = {
  top: {
    title: "Asystent konfiguracji",
    subtitleFallback: "Podstawowa konfiguracja oferty",
    stepCount: "Krok {current} z {total}",
    closeAria: "Zamknij asystenta",
    closeTitle: "Zamknij",
  },
  intro: {
    title: "Skonfigurujmy wspólnie Pana/Pani obiekt!",
    subBefore: "Poprowadzimy Pana/Panią krok po kroku, aby przygotować",
    yourListingFallback: "Pana/Pani ofertę",
    subAfter: "na przyjęcie gości. Wiedza techniczna nie jest potrzebna: wszystko będzie gotowe w kilka minut. 😊",
    start: "Zaczynamy!",
    skip: "Nie teraz, zrobię to później",
  },
  steps: {
    confirmation: {
      label: "Potwierdzenie rezerwacji",
      desc: "Informujemy gościa przez WhatsApp i e-mailem, że jego rezerwacja jest potwierdzona. Po wyłączeniu tej opcji gość nie otrzyma powiadomienia. Jeśli rezerwuje przez OTA, powiadamia go OTA.",
    },
    welcome: {
      label: "Wiadomość powitalna",
      desc: "Wiadomość, którą gość otrzymuje zaraz po ukończeniu check-in online, z powitaniem i instrukcjami przyjazdu.",
    },
    schedule: {
      label: "Harmonogram check-in",
      desc: "Kiedy mamy wysłać gościowi link do check-in?",
    },
    hours: {
      label: "Godziny check-in i check-out",
      desc: "O której godzinie gość może przyjechać i wyjechać?",
    },
    locks: {
      label: "Typ zamka",
      desc: "W jaki sposób gość dostaje się do Pana/Pani obiektu?",
    },
    authorities: {
      label: "Zgłaszanie do organów",
      desc: "Wysyłamy za Pana/Panią zgłoszenie gości do organów, bez żadnych działań z Pana/Pani strony.",
    },
    services: {
      label: "Usługi",
      desc: "Skonfiguruj usługi i udogodnienia oferowane w obiekcie.",
    },
    policies: {
      label: "Polityki",
      desc: "Zasady i warunki obowiązujące w obiekcie.",
    },
    calendar: {
      label: "Przygotuj kalendarz",
      desc: "Pokażemy, jak przygotować kalendarz do przyjmowania rezerwacji.",
    },
  },
  nav: {
    back: "Wstecz",
    next: "Dalej",
    finish: "Zakończ",
  },
  preview: {
    audienceOwner: "Co widzi gospodarz",
    audienceGuest: "Co widzi gość",
    accommodationFallback: "Obiekt",
    online: "online",
    today: "Dzisiaj",
    captionGuestWeb: "Podgląd · strona gościa",
  },
  schedule: {
    title: "Kiedy zaczyna się check-in?",
    hint: "Zaplanuj, kiedy agent wyśle gościowi link do check-in. Obowiązuje na poziomie oferty.",
    caption: "Podgląd · sekwencja check-in",
  },
  // WhatsApp bot sample messages: shown VERBATIM (bilingual ES+EN) in every
  // language because they mirror the actual product message.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "Czy potwierdzenie rezerwacji ma być wysyłane do gościa przez WhatsApp?",
    toggleHint: "Gdy tylko rezerwacja zostanie potwierdzona, gość otrzyma tę wiadomość ze wszystkimi szczegółami pobytu. Dzięki temu wie, że wszystko jest w porządku. 😊",
    stateOn: "Tak, wysyłaj",
    stateOff: "Nie wysyłaj",
    mapAlt: "Lokalizacja obiektu",
    addressFallback: "Adres obiektu",
    caption: "Podgląd · wiadomość z potwierdzeniem",
    propFallback: "Pana/Pani obiekt",
    guestSample: "Laura García",
    body: "Dzień dobry *{guest}* 👋\n\nPana/Pani rezerwacja w *{name}* jest potwierdzona ✅\n\nKod rezerwacji: *6233Q1VC5*\nTermin: *05/06/2026* – *07/06/2026* 📅\n\nPrzez tego WhatsAppa może Pan/Pani poprosić o link do check-in online i otrzymać instrukcje przyjazdu.\nW razie potrzeby pomocy przed pobytem lub w jego trakcie prosimy napisać tutaj 💬",
    cta: "🇬🇧 Aby kontynuować check-in, proszę nacisnąć przycisk *Ok* lub napisać *Ok*.",
  },
  policies: {
    guestBubble: "Aby kontynuować, konieczna jest akceptacja naszego regulaminu i warunków.",
    termsTitle: 'Regulamin · OBIEKT TURYSTYCZNY „{name}”',
    termsBodyLabel: "I.– REJESTRACJA",
    termsBodyText: "Każdy gość, indywidualny lub będący częścią grupy, musi wypełnić formularz rejestracyjny osobno albo na pokój; formularz zostanie udostępniony po przyjeździe lub online.",
    accept: "Akceptuję regulamin i warunki",
  },
  guestPreview: {
    continue: "Kontynuuj",
  },
  authorities: {
    ofTotal: "z {total}",
    heading: "Informacje wymagane na mocy dekretu królewskiego 933/2021 rządu Hiszpanii",
    intro: "Zgodnie z dekretem królewskim 933/2021, obowiązującym od 2 grudnia 2024 r., musimy zebrać poniższe dane, aby spełnić wymogi przepisów bezpieczeństwa.",
    countryLabel: "Kraj zamieszkania",
    sampleCountry: "🇪🇸 Hiszpania",
    cityLabel: "Miejscowość zamieszkania",
    sampleCity: "Málaga",
    addressLabel: "Adres zamieszkania",
    sampleAddress: "Calle Larios 77",
    postalLabel: "Kod pocztowy miejsca zamieszkania",
  },
  locks: {
    embedEmpty: "Aby skonfigurować zamki i dostęp, najpierw dodaj jednostkę do oferty.",
  },
  calendar: {
    iframeTitle: "Przygotuj kalendarz",
    videoSoon: "Film będzie tu dostępny już wkrótce.",
    hint: "Odtwórz film i wykonaj kolejne kroki: w mgnieniu oka kalendarz będzie gotowy do przyjmowania rezerwacji. 🎬",
  },
};
